import { useState } from 'react';
import { Popover, PopoverBody } from 'reactstrap'
import classnames from 'classnames'
import { tr } from 'react-hook-form-auto'

import { Icon } from '../../ui/bootstrap/bootstrap'

import styles from './PlaceChooser.sass'

const buttonId = 'place-chooser-button'

// Compact current-place selector: a pill that opens a popover.
// Renders nothing until the user has created places.
export const PlaceChooser = ({ places, selectedId, onSelect }) => {
  const [ open, setOpen ] = useState(false)

  if (!places || places.length == 0)
    return null

  const selected = places.find(place => place.id == selectedId)

  const toggle = () => {
    setOpen(!open)
  }

  const choose = id => {
    onSelect(id)
    setOpen(false)
  }

  const renderOption = (id, name) => {
    const active = (id || '') == (selectedId || '')
    const classes = classnames(styles.option, {
      [styles.active]: active
    })

    return (
      <div
        key={id || 'all'}
        className={classes}
        onClick={() => choose(id)}
      >
        {name}
      </div>
    )
  }

  return (
    <div className={styles.chooser}>
      <div
        id={buttonId}
        className={classnames(styles.pill, {
          [styles.filtering]: Boolean(selected)
        })}
        onClick={toggle}
      >
        <Icon icon="store" />
        <span className={styles.pillName}>
          {selected ? selected.name : tr('models.place.all')}
        </span>
      </div>
      <Popover
        placement="bottom"
        isOpen={open}
        target={buttonId}
        toggle={toggle}
        popperClassName={styles.pop}
      >
        <PopoverBody>
          {renderOption('', tr('models.place.all'))}
          {places.map(place => renderOption(place.id, place.name))}
        </PopoverBody>
      </Popover>
    </div>
  )
}
